import { roleAccent } from "./organigramaColors";

export const borjaRole = {
  id: "borja",
  section: "1.3",
  name: "Borja",
  subtitle: "EXECUTIVE ROLE CHARTER",
  role: "Chief Operating & Financial Officer (COFO)",
  reportaALabel: "Reports to",
  reportaA: "Founder & Executive Chair",
  accent: roleAccent("borja"),
  foco: [],
  noFoco: [],
  propositoLabel: "Purpose of the Role",
  proposito:
    "The Chief Operating & Financial Officer (COFO) is responsible for transforming the company's strategic objectives into consistent operational and financial performance.\n\nThe role exists to ensure that Stage Design Studio and No Man's Label operate as a profitable, efficient and scalable organisation by aligning people, processes, systems and financial resources.",
  misionLabel: "Mission",
  mision:
    "Support the organisation to be able to deliver outstanding operational and financial performance, disciplined execution, efficient processes and clear accountability  rather than through personal control of every decision.",
  scopeLabel: "Scope of Responsibility",
  scopeIntro: "The COFO has executive responsibility for:",
  scopeItems: [
    "Operations",
    "Production",
    "Merchandising",
    "Logistics",
    "Planning",
    "ERP & Business Systems",
    "Finance",
    "Reporting",
    "Cash Flow",
    "Process Improvement",
    "Organisational Performance",
  ],
  scopeNote:
    "The COFO collaborates closely with Commercial, Design and China Teams to ensure operational alignment but does not own commercial strategy, product strategy or customer development.",
  responsabilidadesLabel: "Key Responsibilities",
  responsabilidades: [
    {
      title: "1. Operational Leadership",
      intro:
        "Responsible for ensuring operational excellence across the organisation.",
      items: [
        "Define operational priorities.",
        "Allocate resources according to business priorities.",
        "Coordinate operations between Spain and Asia.",
        "Ensure customer commitments are fulfilled.",
        "Balance workload, operational capacity and delivery priorities.",
        "Resolve operational issues affecting execution.",
        "Resolve cross-functional conflicts by balancing commercial priorities, operational capability and financial discipline.",
        "Ensure departments collaborate effectively.",
        "Build operational systems that reduce dependency on individuals while maintaining execution speed.",
      ],
      table: {
        caption: "Operational Leads",
        headers: ["Area", "Operational Lead"],
        rows: [
          ["Production", "Imma"],
          ["Merchandising", "Imma"],
          ["Logistics", "Guillermo"],
          ["Order Administration / ERP", "Guillermo"],
          ["Accounting Support", "Anna / Guillermo"],
          ["Development Planning & Timings", "Agustina"],
        ],
      },
    },
    {
      title: "2. Financial Leadership",
      intro:
        "Responsible for maintaining the financial discipline of the organisation.",
      items: [
        "Budget preparation and control.",
        "Forecasting.",
        "Cash Flow management.",
        "Financial Reporting.",
        "Profitability analysis by customer.",
        "Profitability analysis by supplier.",
        "Programme profitability.",
        "Working Capital management.",
        "Financial risk monitoring.",
        "Internal financial controls.",
        "Approval of operational expenditure.",
        "Supervision of grants and subsidies.",
        "Recommendation of operational investments.",
      ],
      table: {
        caption: "Operational Leads",
        headers: ["Area", "Operational Lead"],
        rows: [
          ["Accounting", "Anna / Guillermo"],
          ["Treasury", "Anna / Guillermo"],
          ["Financial Reporting", "Anna / Guillermo"],
        ],
      },
    },
    {
      title: "3. Business Performance",
      intro:
        "Support profitable commercial growth through operational excellence and financial discipline.",
      items: [
        "Provide financial and operational analysis to support commercial decisions.",
        "Assess profitability of key opportunities.",
        "Evaluate operational feasibility before major commitments.",
        "Monitor customer profitability.",
        "Monitor supplier performance.",
        "Balance commercial opportunities with operational capacity.",
        "Contribute operational and financial input to seasonal planning.",
        "Ensure commercial growth can be executed efficiently and profitably.",
      ],
      extraItems: [
        "Commercial decisions remain the responsibility of the Founder, within the strategic framework defined by the Executive Chair.",
      ],
    },
    {
      title: "4. Leadership & Organisation",
      intro:
        "Develop a strong, accountable and increasingly autonomous operational organisation.",
      groups: [
        {
          label: "Direct Reports",
          items: ["Guillermo", "Imma", "Anna", "Merchandising Teams"],
        },
        {
          label: "Cross Functional Collaboration",
          items: [
            "Commercial Team",
            "Design Team",
            "China Teams",
            "Strategic Suppliers",
          ],
        },
      ],
      items: [
        "Develop operational leaders.",
        "Delegate ownership together with accountability.",
        "Clearly define responsibilities and decision rights.",
        "Coach and support operational leaders.",
        "Conduct performance reviews.",
        "Build trust through coaching rather than control.",
        "Encourage collaboration across departments.",
        "Share knowledge across the organisation.",
        "Develop capabilities that reduce dependency on individual contributors.",
        "Intervene directly whenever the business requires it, ensuring every intervention strengthens people, improves processes and reduces future dependency.",
        "Build an organisation capable of consistently delivering results independently of any one individual.",
      ],
    },
    {
      title: "5. Continuous Improvement",
      items: [
        "Improve operational efficiency.",
        "Standardise processes.",
        "Promote digitalisation.",
        "Promote automation.",
        "Improve reporting quality.",
        "Implement and monitor KPIs.",
        "Optimise organisational resources.",
        "Lead continuous improvement initiatives.",
      ],
    },
    {
      title: "6. Governance",
      intro:
        "Where responsibilities overlap, strategic direction remains with the Executive Chair and Founder & Chief Commercial Officer, while operational execution remains the responsibility of the COFO.",
      items: [
        "Participate in the Executive Management Team.",
        "Execute approved strategic priorities.",
        "Ensure operational continuity.",
        "Support strategic decision-making through operational and financial insight.",
        "Maintain organisational capability to support future growth.",
      ],
    },
  ],
  governanceBoundariesLabel: "Governance Boundaries",
  governanceBoundariesIntro:
    "To ensure clear accountability across the Executive Team:",
  governanceBoundaries: [
    "Commercial strategy, customer development and product direction remain the responsibility of the Founder & Chief Commercial Officer, within the strategic framework defined by the Executive Chair.",
    "Product strategy remains the responsibility of the Founder & Chief Commercial Officer.",
    "Organisational strategy and governance remain the responsibility of the Founder & Executive Chair.",
    "Operational execution and financial discipline are the responsibility of the COFO.",
    "The COFO provides operational and financial support to commercial decisions but does not determine customer strategy, pricing policy or product direction.",
    "The COFO has full authority over operational execution within his areas of responsibility.",
  ],
  kpiGroups: [
    {
      title: "Operations",
      items: [
        "On Time Delivery",
        "Operational Productivity",
        "Operational Efficiency",
        "Critical Incidents",
        "Customer Service Level",
      ],
    },
    {
      title: "Financial",
      items: [
        "Gross Margin by Customer",
        "Gross Margin by Supplier",
        "Programme Profitability",
        "Forecast Accuracy",
        "Cash Flow",
        "Working Capital",
        "Budget Compliance",
        "EBITDA",
      ],
    },
    {
      title: "People",
      items: [
        "Development of Operational Leaders",
        "Team Autonomy",
        "Delegation Effectiveness",
        "Performance Reviews Completed",
        "Internal Talent Development",
      ],
    },
    {
      title: "Organisation",
      items: [
        "Process Improvements Implemented",
        "ERP Progress",
        "Automation Projects",
        "Reporting Quality",
        "Operational Scalability",
        "Grants & Subsidies Obtained",
      ],
    },
  ],
  kpis: [],
  kpisLabel: "Key Performance Indicators",
  leadershipExpectationsLabel: "Leadership Expectations",
  leadershipExpectations:
    "The COFO is expected to protect the organisation by consistently delivering of results through capable people, disciplined execution and continuous improvement.",
  decisionMatrixLabel: "Executive Decision Matrix",
  decisionMatrix: {
    headers: ["Area", "Final Decision", "COFO"],
    rows: [
      ["Commercial Strategy", "Founder & EC", "Support"],
      ["Product Strategy", "Founder", "Support"],
      ["Customer Selection", "Founder & EC", "Operational Support"],
      ["Pricing", "Founder & EC", "Financial Analysis"],
      ["Operational Planning", "COFO", "Final Owner"],
      ["Production", "COFO", "Final Owner"],
      ["Logistics", "COFO", "Final Owner"],
      ["Budget", "COFO", "Final Owner"],
      ["Cash Flow", "COFO", "Final Owner"],
      ["ERP/CRM", "EC", "Support"],
      ["Organisation Design", "Founder & EC", "Recommendation"],
      ["Executive Hiring", "Founder & EC", "Recommendation"],
    ],
  },
};
